import { styled } from "@mui/system";
import BreakPoints from "src/general/constants/breakPoints";
import Colors from "../../../general/constants/colors";

export const MainLayout = styled("div")(({ theme }) => ({
	backgroundColor: Colors.GREY_OLD,
	display: "flex",
	gap: theme.spacing(3),
	padding: `${theme.spacing(4)} ${theme.spacing(8)}`,
	[`@media (max-width: ${BreakPoints.FHD_1919}px)`]: {
		gap: theme.spacing(2),
		padding: `${theme.spacing(2)} ${theme.spacing(2)}`,
	},
	[`@media  (min-width: ${BreakPoints.FHD_1919}px)`]: {
		paddingTop: "24px",
	},
}));

export const Content = styled("div")(({ theme }) => ({
	position: "relative",
	minWidth: 0,
	width: "100%",
}));

export const BreadMenuContainer = styled("div")(({ theme }) => ({
	display: "flex",
	backgroundColor: Colors.GREY_OLD,
	paddingLeft: theme.spacing(2),
	width: "100%",

	[`@media  (min-width: ${BreakPoints.FHD_1919}px)`]: {
		paddingTop: "24px",
		paddingLeft: "64px",
	},
}));
